export default "__VITE_ASSET__DVGvvTDC__"